var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDirectories = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 6H2V15C2 15.5523 2.44772 16 3 16H15C15.5523 16 16 15.5523 16 15V7C16 6.44772 15.5523 6 15 6H13ZM8.5 0L11.5 4H15C16.6569 4 18 5.34315 18 7V15C18 16.6569 16.6569 18 15 18H3C1.34315 18 0 16.6569 0 15V6V4V3C0 1.34315 1.34315 0 3 0H8.5ZM9 4L7.5 2H3C2.44772 2 2 2.44772 2 3V4H9Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDirectories, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/directories.ea6e69b7.svg";
export { ForwardRef as ReactComponent };